import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { LoginStorage } from '../../../login/login.storage';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OMNI_MAIS_REDIRECT_BASE_URL} from '../../../../environments/environment';

@Component({
  selector: 'app-plus-modal',
  templateUrl: './plus-modal.component.html',
  styleUrls: ['./plus-modal.component.scss'],
})
export class PlusModalComponent implements OnInit {
  private loginStorage: LoginStorage = inject(LoginStorage);
  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {}

  onAcessarNovoOmni() {
    const login = encodeURIComponent(btoa(this.loginStorage!.usuario.login));
    const token = encodeURIComponent(btoa(this.loginStorage!.usuario.token));
    const agent = encodeURIComponent(
      btoa(JSON.stringify(this.loginStorage.agente)),
    );
    const urlRedirect = encodeURIComponent('visao-geral');
    window.open(
      `${OMNI_MAIS_REDIRECT_BASE_URL}/auth-redirect/${login}/${token}/${agent}?redirectUrl=${urlRedirect}`,
      '_blank',
    );
  }

  onClickClose() {
    this.bsModalRef.hide();
  }
}
